export default "__VITE_ASSET__23bc8745__"